import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const container = document.getElementById('root');

if (container) { // 👈 Element கிடைத்ததா என்று சரிபார்க்கவும்
  const root = ReactDOM.createRoot(container); 

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Console-இல் ஒரு பிழையைக் காட்டலாம்
  console.error("The root element with ID 'root' was not found in the document.");
}